import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface SwitchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, checked, ...rest }, ref) => {
    return (
      <label className={cn("relative inline-flex cursor-pointer items-center", className)}>
        <input
          ref={ref}
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          {...rest}
        />
        <span
          className={cn(
            "h-6 w-11 rounded-full bg-[var(--color-bg-card)] transition-colors",
            "border border-[var(--color-border-subtle)]",
            "peer-checked:bg-gradient-brand peer-checked:border-transparent",
            "peer-disabled:opacity-50 peer-disabled:cursor-not-allowed",
          )}
        />
        <span
          className={cn(
            "pointer-events-none absolute left-0.5 top-0.5 size-5 rounded-full bg-white shadow",
            "transition-transform duration-200",
            "peer-checked:translate-x-5",
          )}
        />
      </label>
    );
  },
);
Switch.displayName = "Switch";
